(() => {
  let lastDrawerTrigger = null;
  const closeDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('zinney-drawer-open');
    lastDrawerTrigger?.focus?.();
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-zinney-drawer-open]');
    if (trigger) {
      const drawer = trigger.closest('.zinney-pdp-conversion')?.querySelector('[data-zinney-drawer]') || document.querySelector('[data-zinney-drawer]');
      if (!drawer) return;
      lastDrawerTrigger = trigger;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('zinney-drawer-open');
      drawer.querySelector(`[data-zinney-drawer-section="${trigger.dataset.zinneyDrawerOpen}"]`)?.scrollIntoView({ block: 'start' });
      drawer.querySelector('[data-zinney-drawer-close]:not([tabindex="-1"])')?.focus();
      return;
    }
    const closer = event.target.closest('[data-zinney-drawer-close]');
    if (closer) closeDrawer(closer.closest('[data-zinney-drawer]'));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer(document.querySelector('[data-zinney-drawer].is-open'));
  });

  document.addEventListener('click', async (event) => {
    const shareButton = event.target.closest('[data-zinney-share]');
    if (!shareButton) return;
    const payload = { title: document.title, text: document.title, url: location.href };
    try {
      if (navigator.share) await navigator.share(payload);
      else {
        await navigator.clipboard.writeText(location.href);
        shareButton.classList.add('is-copied');
        globalThis.setTimeout(() => shareButton.classList.remove('is-copied'), 1500);
      }
    } catch (error) {
      if (error?.name !== 'AbortError') globalThis.open(location.href, '_blank', 'noopener');
    }
  });

  const random = (minimum, maximum) => {
    const min = Math.min(minimum, maximum);
    const max = Math.max(minimum, maximum);
    const span = max - min + 1;
    if (globalThis.crypto?.getRandomValues) {
      const value = new Uint32Array(1);
      globalThis.crypto.getRandomValues(value);
      return min + (value[0] % span);
    }
    return min + Math.floor(Math.random() * span);
  };

  const initialize = (root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const viewer = root.querySelector('[data-zinney-viewers]');
    const sales = root.querySelector('[data-zinney-sales]');
    const update = () => {
      if (viewer) viewer.textContent = random(Number(root.dataset.viewerMin), Number(root.dataset.viewerMax));
      if (sales) sales.textContent = random(Number(root.dataset.salesMin), Number(root.dataset.salesMax));
    };
    update();
    const refresh = Math.max(10, Number(root.dataset.refresh) || 30) * 1000;
    globalThis.setInterval(update, refresh);
  };

  const boot = () => document.querySelectorAll('[data-zinney-pdp-activity]').forEach(initialize);
  const relocateSocial = () => document.querySelectorAll('.zinney-pdp-social').forEach((social) => {
    const purchaseColumn = social.closest('.product-detail__information');
    const buyButtons = purchaseColumn?.querySelector('.product-detail__buy-buttons');
    if (buyButtons && buyButtons.nextElementSibling !== social) buyButtons.insertAdjacentElement('afterend', social);
  });
  const relocateDrawers = () => document.querySelectorAll('[data-zinney-drawer]').forEach((drawer) => {
    if (drawer.parentElement !== document.body) document.body.append(drawer);
  });
  const start = () => { boot(); relocateSocial(); relocateDrawers(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once: true }) : start();
  document.addEventListener('shopify:section:load', start);
})();
